import en from './locale/en';

export default {
  en,
};
